export default __webpack_public_path__ + "static/media/9.9c3184b2.jpg";